<template>
	<div>
		<b-card class="mr-1 p-1" no-body>
			<b-row>
				<b-col class="d-flex align-items-center" cols="10">
					<b-nav pills class="m-0" style="gap: 1rem">
						<b-nav-item
							:to="{ name: 'brain-nursery-diagnostic' }"
							tag="li"
							active-class="nav-link active active-item-nav"
							link-classes="active-item-nav"
						>
							Diagnosticos
						</b-nav-item>
						<b-nav-item
							:to="{ name: 'brain-nursery-treatment' }"
							tag="li"
							active-class="nav-link active active-item-nav"
							link-classes="active-item-nav"
						>
							Tratamientos
						</b-nav-item>
					</b-nav>
				</b-col>
				<b-col class="d-flex justify-content-end" style="gap: 1rem">
					<b-button
						v-if="$route.name == 'brain-nursery-diagnostic'"
						@click="childAction = 'create-diagnostic'"
						variant="success"
					>
						Crear Diagnostico
					</b-button>
					<b-button
						v-if="$route.name == 'brain-nursery-treatment'"
						@click="childAction = 'create-treatment'"
						variant="success"
					>
						Crear Tratamiento
					</b-button>
				</b-col>
			</b-row>
		</b-card>
		<b-card class="p-1" no-body>
			<router-view :action="childAction" @actionDone="childAction = ''" @blocked="actionBlocked = true" />
		</b-card>
	</div>
</template>

<script>
export default {
	data: () => ({
		childAction: "",
		actionBlocked: false,
	}),
	watch: {
		"$route.name"() {
			this.actionBlocked = false
		},
	},
}
</script>
